import { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';

import { FilterTabs } from 'src/components/FilterTabs/FilterTabs';

export type MessageReadFilter =
    | 'all'
    | 'sentByMe'
    | 'sentToAll'
    | 'personal'
    | 'unread'
    | 'noStaffReply';

type FilterOptionsSettings = {
    residentView?: boolean;
    includeNoStaffReply?: boolean;
};

/** One option list for the tabs and the compact dropdown, so both always match. */
export const messageReadFilterOptions = (
    t: TFunction,
    {
        residentView = false,
        includeNoStaffReply = false,
    }: FilterOptionsSettings,
): { value: MessageReadFilter; label: string }[] =>
    (
        [
            'all',
            'sentByMe',
            residentView ? 'personal' : 'sentToAll',
            'unread',
            ...(includeNoStaffReply ? (['noStaffReply'] as const) : []),
        ] as const
    ).map(filter => ({
        value: filter,
        label: t(`modules.messages.filters.${filter}`),
    }));

type MessageReadFilterTabsProps = FilterOptionsSettings & {
    value: MessageReadFilter;
    onChange: (value: MessageReadFilter) => void;
};

export const MessageReadFilterTabs = ({
    value,
    onChange,
    residentView,
    includeNoStaffReply,
}: MessageReadFilterTabsProps) => {
    const { t } = useTranslation();

    return (
        <FilterTabs
            role="tablist"
            label={t('modules.messages.filters.title')}
            value={value}
            onChange={onChange}
            options={messageReadFilterOptions(t, {
                residentView,
                includeNoStaffReply,
            })}
        />
    );
};
